import React, { useEffect, useState } from 'react'
import Layout from '../../common/layout/layout'
import { Row, Col } from 'react-bootstrap'
import { useParams } from 'react-router'
import { getOrderDetail } from '../../../services/orderService'
import { Order, OrderItem } from '../../../models/Order'
import { OrderItemStatus } from '../../../config/enums'
import styles from './trackOrder.module.css'
import { IoIosCheckmark } from 'react-icons/io'
import { friendlyOrderItemStatus } from '../../../utility/orderHelper'

const TrackOrder: React.FC = () => {
  const { orderId, orderItemId } = useParams()
  const [order, setOrder] = useState<Order | undefined>(undefined)
  const [orderItem, setOrderItem] = useState<OrderItem | undefined>(undefined)
  const [currentStepIndex, setCurrentStepIndex] = useState(0)

  const steps = () => {
    return [
      {
        status: OrderItemStatus.placed,
        count: 'One'
      },
      {
        status: OrderItemStatus.processing,
        count: 'Two'
      },
      {
        status: OrderItemStatus.disptached,
        count: 'Three'
      },
      {
        status: OrderItemStatus.delivered,
        count: 'Four'
      }
    ]
  }

  useEffect(() => {
    if (orderId && orderItemId) {
      getOrderDetail(orderId).then(orderDetail => {
        setOrder(orderDetail)
        orderDetail?.orderItems.forEach(oItem => {
          if (oItem.item.id === orderItemId) {
            setOrderItem(oItem)
          }
        })
      })
    }
  }, [orderId, orderItemId])

  useEffect(() => {
    switch (orderItem?.status) {
      case OrderItemStatus.placed:
        setCurrentStepIndex(0)
        break
      case OrderItemStatus.processing:
        setCurrentStepIndex(1)
        break
      case OrderItemStatus.disptached:
        setCurrentStepIndex(2)
        break
      case OrderItemStatus.delivered:
        setCurrentStepIndex(3)
        break
    }
  }, [orderItem])

  return (
    <Layout>
      <div data-testid="orderDetailFC">
        <Row>
          <Col xl={8} className="mx-auto">
            <Row>
              <Col>
                <h1 className="pageTitle">Track Order</h1>
              </Col>
            </Row>

            {orderItem && (
              <>
                <Row>
                  <Col className="text-center text-dark mt-3">
                    <p>
                      Vendor:
                      <br />
                      <span>{orderItem?.vendor.name}</span>
                    </p>
                    Order #:
                    <br />
                    <span>{order?.orderNumber}</span>
                  </Col>
                </Row>

                {steps().map((step, i) => {
                  return (
                    <Row
                      key={step.status}
                      className={`no-gutters ${styles.stepRow}`}
                      data-testid="statusStep"
                    >
                      <Col xs="auto" className="pr-4">
                        {i <= currentStepIndex ? (
                          <span
                            className={`${styles.stepCircle} ${styles.done}`}
                          >
                            <IoIosCheckmark size={80} />
                          </span>
                        ) : (
                          <span
                            className={`${styles.stepCircle} ${styles.todo}`}
                          >
                            {i + 1}
                          </span>
                        )}
                      </Col>
                      <Col className="align-v-center">
                        <div>
                          <div className="text-dark">Step {step.count}</div>
                          <h4>{friendlyOrderItemStatus(step.status)}</h4>
                        </div>
                      </Col>
                    </Row>
                  )
                })}
              </>
            )}
          </Col>
        </Row>
      </div>
    </Layout>
  )
}

export default TrackOrder
